import { Box, Button, Colors, LegendItem, Text } from '@factorialco/deprecated-design-system'
import { Point } from '@nivo/line'
import { InsightsHeadcountFragment } from 'generated/resources/graphql'

import { formatDateRange } from 'modules/core/components/DateNavigator/dateFormatUtils'
import i18n from 'modules/core/lib/i18n'

import ChartTooltip from 'modules/insights/components/ChartTooltip'

import {
  HeadcountEvolutionData,
  findDataFor,
  getColorHeadCount,
  getColorJoiners,
  getColorLeavers,
} from 'modules/insights/components/WidgetHeadcountEvolution/ChartHeadcountEvolution/headcountEvolutionUtils'

type LegendItemProps = {
  color: Colors
  name: string
  value: number
}

const HeadcountLegendItem = ({ color, name, value }: LegendItemProps) => {
  return (
    <LegendItem color={color} flexDirection="row" gap="s4" alignItems="center">
      <Box alignItems="flexStart" width="s120" flexGrow>
        <Text size="200" weight="medium" color="grey100">
          {name}
        </Text>
      </Box>
      <Box>
        <Text size="200" weight="medium" color="grey100">
          {value}
        </Text>
      </Box>
    </LegendItem>
  )
}

type Props = {
  headcountEvolution: InsightsHeadcountFragment[]
  data: HeadcountEvolutionData
  point: Point
  onOpenDetails: () => void
}

// This component needs access to the `data` to be able to render all three metrics
export const HeadcountTooltip = ({ headcountEvolution, data, point, onOpenDetails }: Props) => {
  const headcountForDate = findDataFor(headcountEvolution, data, point.data.x as Date)

  if (!headcountForDate) {
    return null
  }

  const { startDate, endDate, headcount, joiners, leavers } = headcountForDate

  return (
    <ChartTooltip title={formatDateRange(startDate, endDate, true, false)}>
      <Box gap="s16" alignItems="center">
        <Box>
          <HeadcountLegendItem
            color={getColorHeadCount()}
            name={i18n.t('insights.widgets.shared.headcount')}
            value={headcount}
          />
          <HeadcountLegendItem
            color={getColorJoiners()}
            name={i18n.t('insights.widgets.headcount_evolution.joiners')}
            value={joiners}
          />
          <HeadcountLegendItem
            color={getColorLeavers()}
            name={i18n.t('insights.widgets.headcount_evolution.leavers')}
            value={leavers}
          />
        </Box>

        <Button type="secondary-dark" onClick={onOpenDetails}>
          {i18n.t('insights.widgets.headcount_evolution.granular_view_button')}
        </Button>
      </Box>
    </ChartTooltip>
  )
}
